export default __webpack_public_path__ + "static/media/encode.51f82e8b.woff2";